import { useState, useEffect } from "react";

const useFormspectrumEditor = ({ initialValue, onChange: handleChange }) => {
  const [spectrum, setSpectrum] = useState(
    initialValue != null ? initialValue : {}
  );

  const onChange = (data) => {
    setSpectrum((state) => {
      return { ...state, ...data };
    });
  };

  useEffect(() => {
    if (typeof handleChange === "function") {
      handleChange({ id: "spectrum", value: spectrum });
    }
    // eslint-disable-next-line
  }, [JSON.stringify(spectrum)]);

  return { spectrum, initialSpectrum: initialValue, onChange };
};

export default useFormspectrumEditor;
